import React from 'react';
import styles from './FilterMenu.module.scss';
import FilterMenuItem from './FilterMenuItem';
import { renderActiveFilterTerms } from '../utils/renderActiveFilterTerms';
import { useFilter } from '@srcDS/js/tastic/pages/category/hooks/useFilter';

const FilterMenu = ({ facets, activeFilter, setActiveFilter }) => {
  const { handleFacetChange, localFilters, onPriceRangeChange } = useFilter();
  return (
    <nav className={styles.filterMenu} aria-label="Filter options">
      {/** FILTERS */}

      {!activeFilter &&
        facets.map((facet) => <FilterMenuItem key={facet.attributeId} facet={facet} onClick={setActiveFilter} />)}

      {/** TERMS */}
      {activeFilter &&
        renderActiveFilterTerms({
          localFilters,
          activeFilter,
          handleFacetChange,
          onPriceRangeChange,
          showHelperText: true,
          isMobile: true,
        })}
    </nav>
  );
};

export default FilterMenu;
